import PropTypes from '@/common/types/prop.types';

interface StatusModelInterface {
  text: string;
  color: PropTypes.Color;
}

function formatPollStatus(status: string | undefined): StatusModelInterface {
  switch (status) {
    case 'new':
      return {
        text: 'Новый',
        color: 'grey',
      };
    case 'organization':
      return {
        text: 'Формирование',
        color: 'warning',
      };
    case 'process':
      return {
        text: 'Идёт',
        color: 'primary',
      };

    case 'completed':
      return {
        text: 'Завершен',
        color: 'success',
      };

    case 'template':
      return {
        text: 'Шаблон',
        color: 'warning',
      };

    case 'template_launch':
      return {
        text: 'Шаблон запущен',
        color: 'primary',
      };

    case 'deleted':
      return {
        text: 'Удален',
        color: 'secondary',
      };
  }
  return {
    text: 'Ошибка',
    color: 'secondary',
  };
}

function formatReportStatus(status: string | undefined): StatusModelInterface {
  switch (status) {
    case 'new':
      return {
        text: 'Новый',
        color: 'primary',
      };
    case 'process':
      return {
        text: 'Заполнение',
        color: 'warning',
      };

    case 'review':
      return {
        text: 'На утверждении',
        color: 'primary',
      };

    case 'rework':
      return {
        text: 'Требуется доработка',
        color: 'warning',
      };

    case 'approved':
      return {
        text: 'Одобрен',
        color: 'success',
      };

    case 'completed':
      return {
        text: 'Опрос завершен',
        color: 'success',
      };

    case 'rejected':
      return {
        text: 'Отклонен',
        color: 'secondary',
      };
    case 'deleted':
      return {
        text: 'Опрос удален',
        color: 'secondary',
      };
  }
  return {
    text: `Ошибка - ${status}`,
    color: 'secondary',
  };
}

export { formatPollStatus, formatReportStatus };
